module.exports = __webpack_public_path__ + "static/media/jetonlaode.ee8ba2b6.svg";